(function($) {

  	// DOM is fully loaded, safe to manipulate elements
  	$(function() {	

  		if ( $('.trusler-block--buyer-rep-query').length ) {

	  		// =====================================================
	  		// PROPERTY IMAGE SLIDER
	  		// =====================================================

	  		function initBrSplides() {

				document.querySelectorAll('.splide.br-image-slider').forEach(sliderEl => {

					const slideNo = $(sliderEl).find('.br-slide').length;
					//console.log( $(sliderEl) );
					//console.log(slideNo);

					new Splide(sliderEl, {
						type: 'slide',
						perPage: 1,
						perMove: 1,
						arrows: 1 < slideNo ? true : false,
						pagination: false,
						rewind: true,
						autoplay: false,
						pauseOnHover: true,
						speed: 800,				
					}).mount();

				});

			}
			initBrSplides();

	  		// =====================================================
	  		// FEATHERLIGHT GALLERY
	  		// =====================================================

	  		function initBrGalleries() {

		  		$('.br-image-slider').each( function() {

					$(this).find('a.br-gallery').featherlightGallery({
						previousIcon: '«',
						nextIcon: '»',
						galleryFadeIn: 300,

						openSpeed: 300,
						afterOpen: function(event) {
							// "this" is the Featherlight object
							// ".featherlight" is the root container
							this.$instance
						  		.attr('id', 'br-gallery-lightbox')
						  		.addClass('br-gallery-lightbox');
						}				
					});			

				})

			}
			initBrGalleries();

	  		// =====================================================
	  		// AJAX Pagination
	  		// =====================================================

			const $loader = $('.wrap--br-loader');

			if ( $('.wrap--br-pagi').length ) {

			    $(document).on('click', '.wrap--br-pagi a', function (e) {

			        e.preventDefault();       

			        //let pageUrl = $(this).attr('href');
			        //
			        // FYKI - the above version won't work 
			        // 		  - if on localhost
			        // 		  - and/or the pagination link doesn't include the port and the domain,
			        // 		    due to a specific 'format' value in the `paginate_links()` PHP
			        // 		    function configuration
			        // 		  
			        // 		  FIX: you should use `this.href` instead.
			        // 		  
			        //  More on this @here:
			        //  
			        //  https://stackoverflow.com/questions/74767997/failed-to-construct-url-invalid-url#answer-74768629
			        //  
			        let pageUrl = this.href,
			        	page 	= new URLSearchParams(new URL(pageUrl).search).get('paged');

			        const $brWrap = $(this).closest('.wrap--parcel-buyer-rep-query');
			        //console.log($scontainer);

			        console.log(page);

			        // FIX - without the below update, the first page's link loses its href value 
			        // 		 with the first AJAX update, breaking the pagination if the user tries 
			        // 		 to get back to page 1.
			        if ( null === page ) 
			        	page = '1';

			        //console.log(page);	

			        $.ajax({
			            url: mod.ajaxurl,
			            type: 'POST',
			            data: {
			                action: 'br_load_page',
			                page: page,
			            },
			            beforeSend: function (jqXHR, settings) {

							//console.log( jqXHR );
							//console.log( settings );

							$loader.addClass('loading');	

							gsap.to(window, {
								duration: 0.5,
								scrollTo: { y: $brWrap[0], offsetY: 180 },
								ease: "Power1.easeInOut"
							});
			            
			            },
			            success: function (response, textstatus, jqXHRObject) {

							//console.log(response);
							//console.log('textstatus:' + textstatus);
							//console.log(jqXHRObject.responseJSON.message);	

							const $brContainer 	= $brWrap.find('.parcel-buyer-rep-query');

							$brContainer.html(response);

							initBrSplides();
							initBrGalleries();
			                
			                $loader.removeClass('loading');		            
			            
			            },
				      	error: function($xhr){

				      		console.log('AJAX request failed :(');
				      		console.log($xhr);	
			              
			              	// (...)                  

				      	}            

			        });

			    });

			}

			//const tSplide = document.querySelectorAll('.trusler-block--testimonials .splide');

			/*const testBlocksArr = document.querySelectorAll('.trusler-block--testimonials');
			testBlocksArr.forEach(block => {

				ParcelFunctions.inViewport(block, 0.05, 0.15, 'block-in-viewport');

			});*/	

		}

	});

})(jQuery);